import { IconButton } from '@material-ui/core';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import cx from 'classnames';
import { get } from 'lodash';
import { bool, func, oneOfType, string, number } from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reportStep, updateChartAndTableConfig, updateSnapshotConfig } from '../../state/modules/app/reportBuilder/actions';
import styles from './styles.scss';

class DeleteReportItemButton extends Component {
  static propTypes = {
    parentId: string,
    componentId: string,
    isDelete: bool,
    updateChartAndTableConfig: func,
    customClassName: string,
    // currentReportStep: oneOfType(Object.values(reportStep)),
    updateSnapshotConfig: func,
    itemIndex: number,
  }

  handleRemoveFromReport = () => {
    const {
      parentId,
      componentId,
      updateChartAndTableConfig,
      updateSnapshotConfig,
      itemIndex,
    } = this.props;
    // remove chart or table item from report
    const isTemplateUpdatedInCustomizeStep = true;

    parentId && updateChartAndTableConfig && updateChartAndTableConfig(parentId,
      componentId, false, itemIndex, isTemplateUpdatedInCustomizeStep);
    // remove snapshot from report
    !parentId && updateSnapshotConfig && updateSnapshotConfig(componentId, false, isTemplateUpdatedInCustomizeStep);
  }

  render() {
    const { isDelete, customClassName, currentReportStep, parentId } = this.props
    return (
      <React.Fragment>
        { isDelete && currentReportStep === reportStep.customize ? (
          <div className={cx(styles.deleteButton, customClassName)}>
            <IconButton 
              onClick={this.handleRemoveFromReport}
              classes={{ root: cx(styles.customButton, {[styles.snapshot]: !parentId}) }}
            >
              <DeleteOutlineIcon />
            </IconButton>
          </div>
        ) : <React.Fragment />
        }
      </React.Fragment>
    )
  }
}


function mapStateToProps(state) {
  return {
    currentReportStep: get(state, 'reportBuilder.currentStep', reportStep.detail),
  }
}

export default connect(
  mapStateToProps,
  { 
    updateChartAndTableConfig,
    updateSnapshotConfig,
  })(DeleteReportItemButton)